import PlusIcon from '@heroicons/react/solid/esm/PlusIcon.js'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'

import { Collection } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { SpaceImage } from '@tribeplatform/react-components/Space'
import { useSpaceUtil } from '@tribeplatform/react-sdk/hooks'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

export const CollectionMenuHeading = ({
  collections,
  createSpace,
  canCreateSpace,
  ...rest
}: {
  collections: Collection[]
  createSpace: (space: { collectionId: string }) => void
  canCreateSpace: boolean
}) => {
  const { matchPath } = useSpaceUtil()
  const location = useLocation()

  return (
    <NavVertical {...rest}>
      <div className="space-y-2">
        {collections.map(collection => {
          const hasSpaces = collection?.spaces?.totalCount

          if (!hasSpaces && !canCreateSpace) {
            return null
          }
          return (
            <NavVertical.Group key={collection.id}>
              <NavVertical.GroupHeader>
                {collection.name}
              </NavVertical.GroupHeader>
              <NavVertical.Group className="pb-3">
                {collection?.spaces?.edges?.map(({ node: space }) => {
                  const isSpaceActive = matchPath(space, location.pathname)
                  return (
                    <NavVertical.Item
                      as={NavLink}
                      key={space.id}
                      to={space?.relativeUrl || '/'}
                      active={!!isSpaceActive}
                    >
                      <div className="me-3 -ms-1">
                        <SpaceImage space={space} size="xs" />
                      </div>
                      <div className="truncate flex-grow">{space.name}</div>
                      {!!space?.authMemberProps?.unreadPostsCount && (
                        <span className="text-xs rounded-md bg-background-pressed font-medium py-0.5 px-2 text-content-on-background-subdued">
                          {space?.authMemberProps?.unreadPostsCount}
                        </span>
                      )}
                    </NavVertical.Item>
                  )
                })}
                {!hasSpaces ? (
                  <NavVertical.Item
                    as="button"
                    onClick={() => {
                      createSpace({
                        collectionId: collection.id,
                      })
                    }}
                  >
                    <span className="w-6 h-6 -ms-1 me-3 flex justify-center items-center">
                      <PlusIcon className="w-5 h-5" />
                    </span>
                    <span className="truncate">
                      <T id="Generics.AddSpace" defaultMessage="Add {SPACE}" />
                    </span>
                  </NavVertical.Item>
                ) : null}
              </NavVertical.Group>
            </NavVertical.Group>
          )
        })}
      </div>
    </NavVertical>
  )
}
